import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Lexend Deca',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'Lexend Deca, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        },
      },
    },

  MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            background: '#FFF',
            boxShadow: '0 1px 2px 0 rgba(23, 27, 34, 0.05)',
            '& fieldset': {
              borderColor: '#DBE0E6',
              borderWidth: '1px',
            },
            '&:hover fieldset': {
              borderColor: '#DBE0E6',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#DBE0E6',
              borderWidth: '1px',
            },
          },
          '& .MuiInputBase-input': {
            fontWeight: 400,
            color: '#252D38',
            '&::placeholder': {
              color: '#47566A',
              fontWeight: 300,
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DBE0E6',
            borderRadius: '8px',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DBE0E6',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DBE0E6',
            borderWidth: '1px',
          },
        },
        select: {
          fontWeight: 400,
          color: '#252D38',
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontWeight: 300,
          color: '#252D38',
          padding: '12px 16px',
          borderBottom: '1px solid #E5E7EB',
          '&:last-child': {
            borderBottom: 'none',
          },
          '&:hover': {
            backgroundColor: '#F9FAFB',
          },
          '&.Mui-selected': {
            backgroundColor: '#F0F7FF',
            fontWeight: 400,
            '&:hover': {
              backgroundColor: '#E6F2FF',
            },
          },
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          '&.MuiMenu-paper': {
            borderRadius: '8px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            marginTop: '4px',
          },
        },
      },
    },

    MuiList: {
      styleOverrides: {
        root: {
          '&.MuiMenu-list': {
            padding: '0',
          },
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          background: '#FFF',
          boxShadow: '0 1px 2px 0 rgba(23, 27, 34, 0.05)',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DBE0E6',
            borderWidth: '1px',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DBE0E6',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DBE0E6',
            borderWidth: '1px',
          },
        },
        input: {
          fontWeight: 400,
          color: '#252D38',
          '&::placeholder': {
            color: '#47566A',
            fontSize: '14px',
            fontWeight: 300,
            opacity: 1,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          color: '#252D38',
          '&.Mui-focused': {
            color: '#252D38',
          },
        },
      },
    },
  }
});

export default theme;